<app-loading *ngIf="!contentReady"></app-loading>

<div class="container mb-4" *ngIf="contentReady">
  <div class="row additem-content">
    <h2 class="additemhead">{{ 'New client' | translate }}</h2>

    <form class="form" [formGroup]="data" (ngSubmit)="onSubmit()">
      <div class="d-flex flex-column flex-sm-row justify-content-center">
        <div class="col-12 form-container">

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="name"
              placeholder="الاسم"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="specialty"
              placeholder="التخصص"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="university"
              placeholder="الجامعة"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="qualification"
              placeholder="المؤهل"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="number"
              formControlName="graduation_year"
              placeholder="سنة التخرج"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="email"
              formControlName="email"
              placeholder="البريد الإلكتروني"
            />
          </div>

          <div class="form-group checkbox-group">
            <input
              type="checkbox"
              formControlName="transfer_of_sponsorship"
            />
            نقل الكفالة
          </div>

          <div class="form-group checkbox-group">
            <input
              type="checkbox"
              formControlName="offer"
            />
            تم توفير اوفر
          </div>

          <div class="form-group checkbox-group">
            <input
              type="checkbox"
              formControlName="visa"
            />
            التأشيرة
          </div>

          @if(!isUpdatePage){
            <div class="form-group">
              <input
                class="input"
                type="text"
                formControlName="mobile"
                placeholder="رقم الجوال"
              />
            </div>
          }

          <div class="form-group checkbox-group">
            <input
              type="checkbox"
              formControlName="ksa_experience"
            />
            لديه خبرة في السعودية
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="residence_place"
              placeholder="مكان الإقامة"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="birth_place"
              placeholder="مكان الميلاد"
            />
          </div>

          <div class="form-group">
            <label class="date-label">تاريخ الميلاد</label>
            <input
              class="input"
              type="date"
              formControlName="birth_date"
              placeholder="تاريخ الميلاد"
            />
          </div>

          <div class="form-group">
            <textarea
              class="input"
              formControlName="notes"
              placeholder="ملاحظات"
            ></textarea>
          </div>

          <div class="form-group">
            <button
              type="submit"
              class="fromsave accont"
              [disabled]="data.invalid"
            >
              @if(isUpdatePage){
                {{ 'Edit' | translate }}
              }
              @else{
                {{ 'Create Client' | translate }}
              }
            </button>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>